import { Component, OnInit } from '@angular/core';
import {CaixaService} from "../services/caixa.service";
import {ImpressaoService} from "../../services/impressao.service";
import {ConstantsService} from "../../fidelidade/ConstantsService";
import {GridDataResult, PageChangeEvent, PagerSettings} from "@progress/kendo-angular-grid";

@Component({
  selector: 'app-historico-sangrias',
  templateUrl: './historico-sangrias.component.html',
  styleUrls: ['./historico-sangrias.component.scss']
})
export class HistoricoSangriasComponent implements OnInit {
  sangrias: GridDataResult = {
    data: [],
    total: 0
  };
  agora = new Date();
  configImpressao: any;
  carregando = false;
  skip = 0;
  pageSize = 10;
  pageSizes = [10, 20, 50, 100];
  pageable: PagerSettings = {
    buttonCount: 5,
    info: true,
    type: 'numeric',
    pageSizes: this.pageSizes,
    previousNext: true
  };

  constructor(private caixaService: CaixaService, private impressaoService: ImpressaoService,
              private constantsService: ConstantsService) {
    this.carregueHistorico();

    this.constantsService.empresa$.subscribe((empresa: any) => {
      if(empresa)
        this.configImpressao = empresa.configImpressao;
    });
  }

  ngOnInit(): void {
  }

  proximaPagina($event: PageChangeEvent) {
    this.skip = $event.skip;
    this.pageSize = $event.take;
    this.carregueHistorico();
  }

  private carregueHistorico() {
    this.carregando = true;

    this.caixaService.obtenhaHistoricoSangrias(this.skip, this.pageSize).then((historico: any) => {
      this.sangrias = {
        data: historico.registros || [],
        total: Number(historico.quantidade) || 0
      };
      this.carregando = false;
    }).catch((erro: any) => {
      console.log(erro);
      this.sangrias = {data: [], total: 0};
      this.carregando = false;
    });
  }

  imprimir(sangria: any) {
    if(!sangria?.id)
      return this.impressaoService.onErrosImpressao.emit('Nao foi possivel identificar a sangria para impressao');

    const impressora = this.obtenhaImpressoraPadrao();

    if(this.configImpressao?.imprimirTXT) {
      if(!impressora)
        return this.impressaoService.onErrosImpressao.emit('Nenhuma impressora configurada');

      return this.impressaoService.imprimaSangria(sangria, impressora);
    }

    const url = this.impressaoService.getRelatorioSangriaUrl({
      idSangria: sangria.id,
      idImpressora: impressora?.id || impressora?._id,
      a4: impressora?.tamanhoPapel === 'LayoutA4',
      autoPrint: true
    });

    if(!window.open(url))
      this.impressaoService.onErrosImpressao.emit('O navegador bloqueou a janela de impressao');
  }

  private obtenhaImpressoraPadrao() {
    return this.configImpressao?.impressoras?.[0];
  }

}
